import { render, staticRenderFns } from "./ChildrenEditPassword.vue?vue&type=template&id=b6f56b9c"
import script from "./ChildrenEditPassword.vue?vue&type=script&lang=js"
export * from "./ChildrenEditPassword.vue?vue&type=script&lang=js"
import style0 from "./ChildrenEditPassword.vue?vue&type=style&index=0&id=b6f56b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports